import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { verifyAdminMagicLink } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { FullPageLoading } from "../../components/Loading";
import { Eyebrow, HeadingItalic } from "../../components/design";
import { AdminBadge } from "../../components/AdminHeader";

export default function AdminVerifyLink() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { signInWithToken } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) {
      setError("Es wurde kein Login-Token übergeben.");
      return;
    }
    (async () => {
      try {
        const { customToken } = await verifyAdminMagicLink(token);
        await signInWithToken(customToken);
        navigate("/admin", { replace: true });
      } catch (e: any) {
        const code = e?.message || "verify_failed";
        const human =
          code === "token_expired"
            ? "Der Link ist abgelaufen. Bitte einen neuen anfordern."
            : code === "token_already_used"
              ? "Dieser Link wurde bereits verwendet. Bitte einen neuen anfordern."
              : code === "not_admin"
                ? "Dieses Konto ist nicht als Admin freigeschaltet."
                : code === "invalid_token" || code === "missing_token"
                  ? "Der Link ist ungültig."
                  : "Anmeldung fehlgeschlagen.";
        setError(human);
      }
    })();
  }, [token, signInWithToken, navigate]);

  if (!error) return <FullPageLoading label="Admin wird eingeloggt …" />;

  return (
    <div
      className="paper-bg"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 22,
      }}
    >
      <div
        style={{
          background: "var(--paper-50)",
          border: "1px solid rgba(43,26,15,0.10)",
          borderRadius: 14,
          padding: "26px 24px",
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
          boxShadow:
            "0 1px 0 rgba(43,26,15,0.04), 0 14px 24px -8px rgba(43,26,15,0.14)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 12,
          }}
        >
          <AdminBadge />
        </div>
        <Eyebrow>Hinweis</Eyebrow>
        <HeadingItalic size={26}>
          Anmeldung nicht <em>möglich</em>.
        </HeadingItalic>
        <p
          style={{
            fontFamily: "var(--f-body)",
            fontSize: 15,
            color: "var(--ink-soft)",
            margin: "0 0 22px",
          }}
        >
          {error}
        </p>
        <Link
          to="/admin/login"
          className="btn-primary"
          style={{ display: "inline-flex" }}
        >
          Neuen Admin-Link anfordern
        </Link>
      </div>
    </div>
  );
}
